/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactEventConfigType } from './ContactEventConfigType.js';
import {
    ContactEventConfigTypeFromJSON,
    ContactEventConfigTypeFromJSONTyped,
    ContactEventConfigTypeToJSON,
} from './ContactEventConfigType.js';
import type { SentenceEntity } from './SentenceEntity.js';
import {
    SentenceEntityFromJSON,
    SentenceEntityFromJSONTyped,
    SentenceEntityToJSON,
} from './SentenceEntity.js';

/**
 * 
 * @export
 * @interface ContactEventConfig
 */
export interface ContactEventConfig {
    /**
     * 
     * @type {number}
     * @memberof ContactEventConfig
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactEventConfig
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactEventConfig
     */
    triggerLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactEventConfig
     */
    isHidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactEventConfig
     */
    displayName?: string;
    /**
     * 
     * @type {ContactEventConfigType}
     * @memberof ContactEventConfig
     */
    type?: ContactEventConfigType;
    /**
     * 
     * @type {number}
     * @memberof ContactEventConfig
     */
    scriptStepId?: number;
    /**
     * 
     * @type {Array<SentenceEntity>}
     * @memberof ContactEventConfig
     */
    sentences?: Array<SentenceEntity>;
}

/**
 * Check if a given object implements the ContactEventConfig interface.
 */
export function instanceOfContactEventConfig(value: object): boolean {
    return true;
}

export function ContactEventConfigFromJSON(json: any): ContactEventConfig {
    return ContactEventConfigFromJSONTyped(json, false);
}

export function ContactEventConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactEventConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'triggerLabel': json['triggerLabel'] == null ? undefined : json['triggerLabel'],
        'isHidden': json['isHidden'] == null ? undefined : json['isHidden'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'type': json['type'] == null ? undefined : ContactEventConfigTypeFromJSON(json['type']),
        'scriptStepId': json['scriptStepId'] == null ? undefined : json['scriptStepId'],
        'sentences': json['sentences'] == null ? undefined : ((json['sentences'] as Array<any>).map(SentenceEntityFromJSON)),
    };
}

export function ContactEventConfigToJSON(value?: ContactEventConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'triggerLabel': value['triggerLabel'],
        'isHidden': value['isHidden'],
        'displayName': value['displayName'],
        'type': ContactEventConfigTypeToJSON(value['type']),
        'scriptStepId': value['scriptStepId'],
        'sentences': value['sentences'] == null ? undefined : ((value['sentences'] as Array<any>).map(SentenceEntityToJSON)),
    };
}

